module.exports = __webpack_public_path__ + "icons/original/large/large-b4.cde289fd73095da992ec76470fcaf001.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-b4.png
// module id = BRDO
// module chunks = app